import { GET_GENRE, GET_RBAC } from "../actions/ActionTypes";

const initialState = {
    data: [],
    page: 1,
    total: 0,
    totalPages: 0,
    isLoading: true,
};
const initial = false;
function RbacReducer(state = initialState, actions) {
    if (actions.type === GET_RBAC) {
        return {
            ...state,
            data: [...actions.payload]
        };
    }
    if (
        actions.type === "LOADING" &&
        actions.payload.action_model === GET_RBAC
    ) {
        return {
            ...state,
            isLoading: actions.payload.loading,
        };
    }
    return state;
}

export { RbacReducer };
